import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectInvoiceDataV2 } from "../../../../store/slices/aufmassV2Slice";
import { getFormattedDate } from "../../../../utils/method";

function InvoiceHeaderV2() {
    const { t } = useTranslation();
    const invoiceData = useSelector(selectInvoiceDataV2);

    const fields = [
        { label: t("invoice.invoice-number"),            value: invoiceData?.invoiceNumber },
        { label: t("invoice.invoice-date"),              value: getFormattedDate(invoiceData?.invoiceDate || '') },
        { label: t("invoice.billing-period-from"),       value: getFormattedDate(invoiceData?.billingPeriodFrom || '') },
        { label: t("invoice.billing-period-to"),         value: getFormattedDate(invoiceData?.billingPeriodTo || '') },
        { label: t("invoice.internal-reference-number"), value: invoiceData?.internalReferenceNumber },
        { label: t("invoice.order-number"),              value: invoiceData?.orderNumber },
        { label: t("invoice.order-date"),                value: getFormattedDate(invoiceData?.orderDate || '') },
        { label: t("invoice.invoice-arrival-date"),      value: getFormattedDate(invoiceData?.invoiceArrivalDate || '') },
        { label: t("invoice.cash-discount-date"),        value: getFormattedDate(invoiceData?.cashDiscountDate || '') },
    ].filter(f => f.value);

    return (
        <div className="aufmass-panel-section">
            <div className="aufmass-panel-section-title">{t("invoice.details")}</div>
            {fields.map((f, i) => (
                <div key={i} className="aufmass-panel-field-row">
                    <span className="aufmass-panel-field-label">{f.label}</span>
                    <span className="aufmass-panel-field-value">{f.value}</span>
                </div>
            ))}
        </div>
    );
}

export default InvoiceHeaderV2;
